module.exports = __webpack_public_path__ + "img/bg6.75ae012.png";